export const PERSONA_TEMPLATE_ID = process.env.REACT_APP_PERSONA_TEMPLATE_ID
export const PERSONA_ENV = process.env.REACT_APP_PERSONA_ENVIRONMENT
export const PERSONA_ENV_ID = process.env.REACT_APP_PERSONA_ENVIRONMENT_ID

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL

export const ONRAMPER_DEV_KEY = process.env.REACT_APP_ONRAMPER_DEV_KEY
export const ONRAMPER_PROD_KEY = process.env.REACT_APP_ONRAMPER_PROD_KEY
